/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const morningHabits = useStore((state) => state.morningHabits);
  const setMorningHabits = useStore((state) => state.setMorningHabits);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.morningHabits.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={morningHabits}
          onChange={(value) => {
            setMorningHabits(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'morning-habits',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'With breakfast'}>
          <span>🍳</span> {t('onboarding.morningHabits.options.breakfast')}
          </Option>
          <Option value={'Coffee and scrolling my phone'}>
          <span>☕</span> {t('onboarding.morningHabits.options.coffeePhone')}
          </Option>
          <Option value={'No food until lunch'}>
          <span>🙃</span> {t('onboarding.morningHabits.options.noFoodUntilLunch')}
          </Option>
          <Option value={'Rushing out the door'}>
          <span>🏃‍♀️</span> {t('onboarding.morningHabits.options.rushingOut')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
